/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import * as api from '@/api/user';
import { USER } from '@/store/types';
import { UserAccess } from '@/api/types/user';

export interface StoreUserAccessState {
  access: UserAccess;
}

export default {
  namespaced: true,
  state: {
    access: null,
  },
  getters: {},
  actions: {
    [USER.GET_ACCESS]({ commit }) {
      return new Promise((resolve, reject) => {
        api.getAccess().then((res) => {
          commit(USER.GET_ACCESS, res.data);
          resolve();
        }).catch(reject);
      });
    },
  },
  mutations: {
    [USER.GET_ACCESS](state, data) {
      if (data.sign.wday === 0) {
        data.sign.wday = 7;
      }
      state.access = data;
    },
  },
};
